/**
 * @generated SignedSource<<d426159842e9c72e397c3da58dd41dbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDistinction_seller$data = {
  readonly isDistinguished: boolean | null;
  readonly isRewardsTier2: boolean | null;
  readonly sellerTiers: {
    readonly isGoldTier: boolean | null;
    readonly isPlatinumTier: boolean | null;
    readonly sellerTierDataNotFound: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpSharedDealerDistinction_seller";
};
export type PdpSharedDealerDistinction_seller$key = {
  readonly " $data"?: PdpSharedDealerDistinction_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDistinction_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDistinction_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDistinguished",
      "storageKey": null
    },
    {
      "alias": "isRewardsTier2",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "kind": "ScalarField",
      "name": "isAnchorListMember",
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerTiers",
      "kind": "LinkedField",
      "name": "sellerTiers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGoldTier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPlatinumTier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerTierDataNotFound",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "0b360d1612bfbcf4605f3e865af5073c";

export default node;
